import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } });
  const [token, setToken]     = useState(() => localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  const saveAuth = (tokenVal, userData) => {
    localStorage.setItem('token', tokenVal);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(tokenVal);
    setUser(userData);
  };

  const clearAuth = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const verifyToken = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.me();
      setUser(res.data.user);
      localStorage.setItem('user', JSON.stringify(res.data.user));
    } catch { clearAuth(); }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => { verifyToken(); }, [verifyToken]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    saveAuth(res.data.token, res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch {}
    clearAuth();
  };

  const refreshUser = async () => {
    const res = await authAPI.me();
    setUser(res.data.user);
    localStorage.setItem('user', JSON.stringify(res.data.user));
  };

  return (
    <AuthContext.Provider value={{
      user, token, loading, login, logout, refreshUser,
      isAdmin: user?.role === 'admin' || user?.role === 'superadmin',
      isSuperAdmin: user?.role === 'superadmin',
      isAuthenticated: !!token,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
